import AdditionalSteps from '../http/additionalSteps'
import MagicToken from './magicToken'

export default class AdditionalStepsService {
  static async getWotcWithToken (postingId) {
    const response = await AdditionalSteps.getWotcWithToken(postingId, MagicToken.getJwt())
    return response.data
  }
}
